import { z } from 'zod';
import { WEBHOOKS_ENDPOINT_TOPIC } from 'src/features/webhook-endpoints/utils/types';
import { validationMessagesMap } from 'src/utils/messages'; /**/

export const webhookEndpointFormSchema = z.object({
    url: z.url({ message: validationMessagesMap.validationErrorURL }).nonempty(),
    description: z.string().optional(),
    is_active: z.boolean().nullable(),
    topics: z.array(z.enum(WEBHOOKS_ENDPOINT_TOPIC)).nonempty(),
});
export type WebhookEndpointSchemaValues = z.infer<typeof webhookEndpointFormSchema>;

export type PatchWebhookEndpointSchemaValues = z.infer<typeof patchWebhookEndpointFormSchema>;
export const patchWebhookEndpointFormSchema = webhookEndpointFormSchema.partial();
